<div [className]="item.name.toLowerCase() + ' insight-card'">
  <mat-card appearance="outlined">
    <mat-card-content>
      <mat-card-title style="display: flex; flex-direction: row;">
        <span style="flex: 1 1 auto;">
          {{ item.name | translate }}
          @if (item.executiveSummaryOnly) {
          <span class="is-executive-summary">({{ 'Executive summary only' | translate }})</span>
          }
          @if (loading) {
          <mat-spinner [diameter]="20"></mat-spinner>
          }
          @if (showMistakes && adjustedChanges) {
          <mat-icon [color]="compareMode ? 'warn' : 'primary'" (click)="compare()">history</mat-icon>
          }
        </span>
        @switch (item.kind) {
          @case (0) { <mat-icon>warning</mat-icon> }
          @case (1) { <mat-icon>equalizer</mat-icon> }
          @case (2) { <mat-icon>thumbs_up_down</mat-icon> }
          @case (3) { <mat-icon>visibility</mat-icon> }
        }
      </mat-card-title>

      @if (compareMode) {
      <div class="old-value" [innerHTML]="oldValue('text') | safeHtml"></div>
      }
      <div [innerHTML]="itemText | async | safeHtml"></div>

      @if (item.attachments) {
      <div class="attachments-grid" style="margin-top: 30px;">
        @for (attachment of item.attachments; track attachment) {
        <div>
          <app-attachment
            [data]="attachment"
            [admin]="admin"
            (edit)="editAttachment.emit(attachment)"
            (remove)="removeAttachment.emit(attachment)"
            (reelClick)="reelClick.emit($event)"
          ></app-attachment>
        </div>
        }
      </div>
      }
      @if (item.kind === InsightKind.Trend) {
      <div>
        <button
          mat-button
          [routerLink]="['/locations', locationId, 'analytics', 'employees']"
          [queryParams]="{ startDate: startDate, endDate: endDate }"
        >
          <mat-icon fontSet="material-icons-outlined">people</mat-icon>
          {{ 'Go to Employee Insights' | translate }}
        </button>
        <button
          mat-button
          [routerLink]="['/locations', locationId, 'analytics', 'sales']"
          [queryParams]="{ startDate: startDate, endDate: endDate }"
        >
          <mat-icon fontSet="material-icons-outlined">monetization_on</mat-icon>
          {{ 'Go to Sales Insights' | translate }}
        </button>
      </div>
      }

      <ng-content></ng-content>
    </mat-card-content>
    @if (admin) {
    <mat-card-actions>
      <button mat-button (click)="edit.emit()">
        <mat-icon>edit</mat-icon>
        EDIT
      </button>
      <button mat-button (click)="delete.emit()">
        <mat-icon>delete</mat-icon>
        DELETE
      </button>
      <button mat-button (click)="addAttachment.emit()">
        <mat-icon>attachment</mat-icon>
        ADD ATTACHMENT
      </button>
      @if (item.isGenerated) {
      <button mat-button (click)="regenerate.emit()">
        <mat-icon>replay</mat-icon>
        REGENERATE
      </button>
      }
    </mat-card-actions>
    }
  </mat-card>
</div>
